import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import useHiddenPlanLabelsStore from 'src/components/scene/PlanLabelController/hiddenLabelsStore'

/**
 * Hide plan labels (by element guid) from the batched floorplan render —
 * e.g. `PlanLabelController` uses this to hide a selected label's descriptor
 * while it draws that label's own movable copy in its place. The element
 * itself stays visible; only its label is hidden. Mirrors `useHideElements` /
 * `useHideFloorplanElements`.
 */
const useHideLabels = (ids: string[] | string | null | undefined) => {
  const addHiddenIdGroup = useHiddenPlanLabelsStore(state => state.addHiddenIdGroup)
  const removeHiddenIdGroup = useHiddenPlanLabelsStore(state => state.removeHiddenIdGroup)

  useLayoutEffect(() => {
    if (!ids || ids.length === 0) return

    const actualIds = Array.isArray(ids) ? ids : [ids]
    const uuid = v4()

    addHiddenIdGroup(uuid, actualIds)

    return () => {
      removeHiddenIdGroup(uuid)
    }
  }, [addHiddenIdGroup, removeHiddenIdGroup, ids])
}

export default useHideLabels
